import React from 'react'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import classNames from 'classnames'
import type { ScheduleJobDialogClasses } from './useScheduleJobDialogStyles'

interface SelectFieldProps {
  classes: ScheduleJobDialogClasses
  active: boolean
  placeholder: string
  value?: string | null
  onToggle: () => void
}

export default function SelectField({ classes, active, placeholder, value, onToggle }: SelectFieldProps) {
  return (
    <button
      type="button"
      className={classNames(classes.selectField, active && classes.selectFieldActive)}
      onClick={onToggle}
      aria-expanded={active}
    >
      <span className={classNames(classes.selectFieldText, !value && classes.selectFieldPlaceholder)}>
        {value ?? placeholder}
      </span>
      <KeyboardArrowDownIcon className={classes.selectFieldIcon} />
    </button>
  )
}
